import artiModhwadia from '../../../assets/images/Auth/clientsAvatars/arti-modhwadia.jpg';
import davidCorts from '../../../assets/images/Auth/clientsAvatars/david-corts.jpg';
import jasonPinto from '../../../assets/images/Auth/clientsAvatars/jason-pinto.jpg';
import jonathanKennell from '../../../assets/images/Auth/clientsAvatars/jonathan-kennel.jpg';
import kailyIronsFuda from '../../../assets/images/Auth/clientsAvatars/kaily-irons-fuda.jpg';
import tyranSpeed from '../../../assets/images/Auth/clientsAvatars/tyran-speed.jpg';

export interface ClientTestimonial {
  id: string;
  avatar: string;
  linkedinUrl: string;
}

export const CLIENT_TESTIMONIALS: ClientTestimonial[] = [
  {
    id: 'davidCorts',
    avatar: davidCorts,
    linkedinUrl: 'https://www.linkedin.com/in/dcorts/',
  },
  {
    id: 'kailyIronsFuda',
    avatar: kailyIronsFuda,
    linkedinUrl: 'https://www.linkedin.com/in/kailyirons-fuda/',
  },
  {
    id: 'jasonPinto',
    avatar: jasonPinto,
    linkedinUrl: 'https://www.linkedin.com/in/jason-pinto/',
  },
  {
    id: 'artiModhwadia',
    avatar: artiModhwadia,
    linkedinUrl: 'https://www.linkedin.com/in/arti-modhwadia/',
  },
  {
    id: 'jonathanKennell',
    avatar: jonathanKennell,
    linkedinUrl: 'https://www.linkedin.com/in/jonathankennell/',
  },
  {
    id: 'tyranSpeed',
    avatar: tyranSpeed,
    linkedinUrl: 'https://www.linkedin.com/in/tyran-speed-cpa-60a44bb9/',
  },
];
